import { c as _c } from "react/compiler-runtime";
import type { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import type { ApiWaveType } from "@/generated/models/ApiWaveType";
import type { ApiCreateGroup } from "@/generated/models/ApiCreateGroup";
import { CREATE_WAVE_GROUPS } from "@/helpers/waves/waves.constants";
import type { CreateWaveGroupConfigType, WaveGroupsConfig } from "@/types/waves.types";
import CreateWaveWarning from "../utils/CreateWaveWarning";
import CreateWaveGroup from "./CreateWaveGroup";
export default function CreateWaveGroups(t0) {
  const $ = _c(28);
  const {
    waveName,
    waveType,
    groups,
    onGroupSelect,
    onInlineGroupCreate,
    chatEnabled,
    adminCanDeleteDrops,
    groupsCache,
    setChatEnabled,
    setDropsAdminCanDelete
  } = t0;
  const isRestrictedGroup = !!groups.admin && !!groups.canView;
  const t1 = CREATE_WAVE_GROUPS[waveType];
  let t2;
  if ($[0] !== adminCanDeleteDrops || $[1] !== chatEnabled || $[2] !== groups || $[3] !== groupsCache || $[4] !== onGroupSelect || $[5] !== onInlineGroupCreate || $[6] !== setChatEnabled || $[7] !== setDropsAdminCanDelete || $[8] !== t1 || $[9] !== waveName || $[10] !== waveType) {
    let t3;
    if ($[12] !== adminCanDeleteDrops || $[13] !== chatEnabled || $[14] !== groups || $[15] !== groupsCache || $[16] !== onGroupSelect || $[17] !== onInlineGroupCreate || $[18] !== setChatEnabled || $[19] !== setDropsAdminCanDelete || $[20] !== waveName || $[21] !== waveType) {
      t3 = groupType => <CreateWaveGroup key={groupType} waveName={waveName} groupType={groupType} waveType={waveType} chatEnabled={chatEnabled} groupsCache={groupsCache} groups={groups} adminCanDeleteDrops={adminCanDeleteDrops} setChatEnabled={setChatEnabled} onGroupSelect={group => onGroupSelect({
        group,
        groupType
      })} onInlineGroupCreate={onInlineGroupCreate} setDropsAdminCanDelete={setDropsAdminCanDelete} />;
      $[12] = adminCanDeleteDrops;
      $[13] = chatEnabled;
      $[14] = groups;
      $[15] = groupsCache;
      $[16] = onGroupSelect;
      $[17] = onInlineGroupCreate;
      $[18] = setChatEnabled;
      $[19] = setDropsAdminCanDelete;
      $[20] = waveName;
      $[21] = waveType;
      $[22] = t3;
    } else {
      t3 = $[22];
    }
    t2 = t1.map(t3);
    $[0] = adminCanDeleteDrops;
    $[1] = chatEnabled;
    $[2] = groups;
    $[3] = groupsCache;
    $[4] = onGroupSelect;
    $[5] = onInlineGroupCreate;
    $[6] = setChatEnabled;
    $[7] = setDropsAdminCanDelete;
    $[8] = t1;
    $[9] = waveName;
    $[10] = waveType;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[23] !== isRestrictedGroup) {
    t3 = isRestrictedGroup && <CreateWaveWarning title="Warning: Limited Access" description={" This wave is configured with restricted access. It can only be viewed\n        and managed by the members of the \"Who can view\" and\n        \"Admin\" groups. If you are not a member of either of these\n        groups, you will not be able to access this wave."} />;
    $[23] = isRestrictedGroup;
    $[24] = t3;
  } else {
    t3 = $[24];
  }
  let t4;
  if ($[25] !== t2 || $[26] !== t3) {
    t4 = <div className="tw-flex tw-flex-col tw-gap-y-6">{t2}{t3}</div>;
    $[25] = t2;
    $[26] = t3;
    $[27] = t4;
  } else {
    t4 = $[27];
  }
  return t4;
}